
const priceTick = {
  namespaced: true,
  state: {
    priceTick: '',
  },
  mutations: {
    changePriceT(state, val) {
      state.priceTick = val;
    },
  },
};

export default priceTick;



// WEBPACK FOOTER //
// ./src/store/priceTick/priceTick.ts